import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import { FileText, Users, DollarSign, TrendingUp } from "lucide-react";
import "../styles/Admin.css";
import { getAllUsers } from "../ServiceAPI/AdminUser/api";
import { getAllApplications } from "../ServiceAPI/AdminUser/applicationapi";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [applications, setApplications] = useState([]);

  // Fetch users from backend
  useEffect(() => {
    async function fetchUsers() {
      try {
        const data = await getAllUsers();
        if (Array.isArray(data)) {
          setUsers(data);
        } else if (Array.isArray(data.users)) {
          setUsers(data.users);
        } else if (Array.isArray(data.data)) {
          setUsers(data.data);
        } else {
          setUsers([]);
        }
      } catch (err) {
        setUsers([]);
      }
    }
    fetchUsers();
  }, []);

  // Fetch applications from backend
useEffect(() => {
  async function fetchApplications() {
    try {
      const data = await getAllApplications();
      console.log("getAllApplications response:", data);
      if (Array.isArray(data)) {
        setApplications(data);
      } else if (Array.isArray(data.applications)) {
        setApplications(data.applications);
      } else if (Array.isArray(data.data)) {
        setApplications(data.data);
      } else {
        setApplications([]);
      }
    } catch (err) {
      setApplications([]);
    }
  }
  fetchApplications();
}, []);

    // Check authentication
  useEffect(() => {
    const isAdminAuthenticated = localStorage.getItem("adminAuth") === "true";
    if (!isAdminAuthenticated) {
      navigate("/admin/login");
    }
  }, [navigate]);

  return (
    <AdminLayout>
      <div className="dashboard-header">
        <h2 className="dashboard-title">Dashboard Overview</h2>
        <p className="dashboard-subtitle">Welcome to your admin dashboard</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card-modern">
          <div className="stat-card-icon applications">
            <FileText size={28} />
          </div>
          <div className="stat-card-content">
            <p className="stat-label">Total Applications</p>
            <h3 className="stat-value">{applications.length}</h3>
            <p className="stat-trend positive">
              <TrendingUp size={16} />
              <span>Active</span>
            </p>
          </div>
        </div>

        <div className="stat-card-modern">
          <div className="stat-card-icon pending">
            <FileText size={28} />
          </div>
          <div className="stat-card-content">
            <p className="stat-label">Pending Approvals</p>
            <h3 className="stat-value">
              {applications.filter(app => (app.ApplicationStatus || app.status || '').toLowerCase() === "pending").length}
            </h3>
            <p className="stat-trend neutral">
              Needs Review
            </p>
          </div>
        </div>

        <div className="stat-card-modern">
          <div className="stat-card-icon users">
            <Users size={28} />
          </div>
          <div className="stat-card-content">
            <p className="stat-label">Total Users</p>
            <h3 className="stat-value">{users.length}</h3>
            <p className="stat-trend positive">
              <TrendingUp size={16} />
              <span>Growing</span>
            </p>
          </div>
        </div>

        <div className="stat-card-modern">
          <div className="stat-card-icon revenue">
            <DollarSign size={28} />
          </div>
          <div className="stat-card-content">
            <p className="stat-label">Revenue</p>
            <h3 className="stat-value">₹0</h3>
            <p className="stat-trend neutral">
              This Month
            </p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;